module.exports = __webpack_public_path__ + "static/media/sydney-swans-logo.2d6b75d7.svg";